module.exports = __webpack_public_path__ + "static/img/nz-red.afdc959.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nz-red.svg
// module id = yDTH
// module chunks = 1